import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import system from '../../system';
import Label from '../Label';
import Message from '../Message';
import Input from '../Input';
import Box from '../Box';
const SYSTEM_PROPS = ['flexProps', 'positioningProps', 'marginProps', 'widthProps', 'floatProps'];
export const createLabelId = id => `${id}-label`;
export const createMessageId = id => `${id}-message`;
const TextField = /*#__PURE__*/function () {
  const TextField = /*#__PURE__*/forwardRef((_ref, ref) => {
    let {
      accessibilityLabelClearButton,
      action,
      clearButton,
      disabled,
      error,
      iconLeft,
      iconLeftComponent,
      iconRight,
      iconRightComponent,
      id,
      label,
      labelHidden,
      labelProps,
      mask,
      message,
      name,
      onChange,
      onIconLeftClick,
      onIconRightClick,
      optionalLabel,
      success,
      type,
      onRequestClear,
      value,
      ...props
    } = _ref;
    const labelId = createLabelId(id);
    const messageId = createMessageId(id);
    const [className, style, rest] = system(props, SYSTEM_PROPS);
    return /*#__PURE__*/React.createElement("div", {
      className: className,
      style: style
    }, /*#__PURE__*/React.createElement(Box, {
      mb: 3,
      clone: true
    }, /*#__PURE__*/React.createElement(Label, _extends({
      action: action,
      hidden: labelHidden,
      htmlFor: id,
      id: labelId,
      optional: optionalLabel
    }, labelProps), label)), /*#__PURE__*/React.createElement(Input, _extends({
      disabled: disabled,
      error: error,
      iconLeft: iconLeft,
      iconLeftComponent: iconLeftComponent,
      iconRight: iconRight,
      iconRightComponent: iconRightComponent,
      onIconLeftClick: onIconLeftClick,
      onIconRightClick: onIconRightClick,
      id: id,
      ref: ref,
      labelId: labelId,
      messageId: message && messageId,
      name: name,
      onChange: onChange,
      required: !optionalLabel,
      type: type,
      value: value,
      mask: mask,
      clearButton: clearButton,
      onRequestClear: onRequestClear,
      success: success,
      accessibilityLabelClearButton: accessibilityLabelClearButton
    }, rest)), message && /*#__PURE__*/React.createElement(Box, {
      pt: 2,
      clone: true
    }, /*#__PURE__*/React.createElement(Message, {
      error: error,
      id: messageId
    }, message)));
  });
  TextField.displayName = 'TextField';
  TextField.identifier = TextField.displayName; // used in docs website
  TextField.clonableProps = SYSTEM_PROPS;
  TextField.defaultProps = {
    accessibilityLabelClearButton: 'Clear',
    type: 'text'
  };
  return TextField;
}();
export default TextField;